import { Component, ElementRef, OnDestroy, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Subject } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdminService } from "../admin.service";
import { environment } from "src/environments/environment";
import * as maplibregl from "maplibre-gl";

declare var $: any;
declare var google: any;

@Component({
  selector: "app-admin-track-new",
  templateUrl: "./admin-track-new.component.html",
  styleUrls: ["./admin-track-new.component.css"],
})
export class AdminTrackNewComponent implements OnInit, OnDestroy, AfterViewInit {
  adminTrack: FormGroup;
  token: any;
  center: [number, number] = [78.9629, 20.5937]; // Center of India [lng, lat]
  zoom = 5.11;
  map!: maplibregl.Map;
  maplibreMarkers: maplibregl.Marker[] = [];

  truckNo: any = "";
  distanceKM: number = 0;
  truckSearchOn = false;

  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  completePickUpAddress: any;
  pickup_short_name: any = "";
  pickup_long_name: any = "";
  pickup_postal_code: any;

  @ViewChild("pickUpLocationSearchField") pickUpLocation: ElementRef | any;

  markerPositions: any = [];
  markerPositionsTemp: any = [];
  trackArray: any = [];
  resArray: any = [];
  isLoading = false;
  search_btn = true;
  clear_btn = false;
  intransit = false;
  truckStatus = false;
  truckOfflineStatus = false;
  statusOffline = "OFFLINE";
  arrayMarker: any;
  selectedTruck: any = null;
  isSelectedTruck: any;
  isReset = true;
  isDistanceFieldDisabled = true;
  isSearchButtonDisabled = true;
  dummyValue: any;
  subscriptions: any[] = [];
  intervalId: any;
  routeIntervalId: any;
  currentRoutePoints: any[] = [];
  currentRouteSegments: any[] = [];
  shouldGetTrack = true;
  trucksInRadius: any[] = [];
  statusText = "";
  isRouteLoaded = false;
  routeVisible = true;

  constructor(
    private services: AdminService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.center = [position.coords.longitude, position.coords.latitude];
      },
      (err) => {
        console.warn("Could not retrieve current geolocation:", err);
      }
    );

    this.adminTrack = this.fb.group({
      truckNo: [""],
    });

    localStorage.setItem("tripType", "track-new");
  }

  ngAfterViewInit(): void {
    if (this.shouldGetTrack) {
      this.getTrack();
    }

    this.initializeMap();
  }

  async initializeMap() {
    let styleJson: any;
    try {
      // 1. Fetch visual map style locally
      styleJson = await this.http
        .get("/assets/map-styles/maptiler-streets-local.json")
        .toPromise();

      // 2. Inject vector tile URL from environments properties
      if (styleJson.sources && styleJson.sources.openmaptiles) {
        styleJson.sources.openmaptiles.url = environment.tile_server_url;
        console.log("Map Style loaded! Tile URL injected:", environment.tile_server_url);
      } else {
        console.warn("Map style loaded, but 'openmaptiles' source was not found.");
      }
    } catch (e) {
      console.error("Failed to load map style (/assets/...). Using blank fallback:", e);
      styleJson = {
        version: 8,
        sources: {},
        layers: [
          {
            id: "bg",
            type: "background",
            paint: { "background-color": "#f2ead8" },
          },
        ],
      };
    }

    this.map = new maplibregl.Map({
      container: "map-container",
      center: this.center,
      zoom: this.zoom,
      minZoom: 5.11,
      maxZoom: 18.06,
      maxBounds: [
        [67.67457, 5.896067], // Southwest coordinates of India bounds
        [97.41989, 35.730908] // Northeast coordinates of India bounds
      ],
      style: styleJson,
      transformRequest: (url, resourceType) => {
        if (url.includes(environment.tile_server_url)) {
          return {
            url: url,
            headers: { 'X-API-Key': environment.tile_api_key }
          };
        }
        return { url };
      }
    });

    this.map.addControl(new maplibregl.NavigationControl(), "top-right");
    this.map.addControl(new maplibregl.FullscreenControl(), "top-right");
    this.map.on("load", () => {
      this.refreshMaplibreMarkers();
    });
  }

  onInputKeyUp(event: any) {
    const value = event.target.value;
    if (value) {
      this.truckNo = value.toUpperCase();
    }
  }



  onInputPickUpchange() {
    // Left for backward compatibility
  }

  getTrack() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.isLoading = true;

    const subscription = this.services
      .Track(this.token)
      .subscribe(
        (response: any) => {
          this.resArray = response.body.record;
          this.resArray = this.resArray
            .map((item: any) => {
              item.truck_location_history =
                item.truck_location_history_dynamic ||
                item.truck_location_history_static;
              return item;
            })
            .filter((item: any) => item.truck_location_history);

          if (this.initialTruckData.length === 0) {
            this.initialTruckData = [...this.resArray];
          }

          if (this.shouldGetTrack) {
            this.trackArray = this.resArray;
          }

          if (response.status === 200) {
            this.isLoading = false;
            this.clearPreviousTruckLocation();

            this.markerPositions = [];
            for (let i = 0; i < this.resArray.length; i++) {
              this.addMarker({
                trip_id: this.resArray[i]?.tripdetails?.trip_id,
                tripdetails: this.resArray[i]?.tripdetails,
                truckNumber:
                  this.resArray[i]?.truck_location_history?.vehicleNumber,
                mobile: this.resArray[i]?.driverDetails?.mobile,
                driverName: this.resArray[i]?.driverDetails?.username,
                truckStatus:
                  this.resArray[i]?.driverRouteDetails?.driver_route_status,
                startdate:
                  this.resArray[i]?.truck_location_history?.trackDateTime,
                tripStatus: this.resArray[i]?.tripdetails?.trip_status,
                address: this.resArray[i]?.truck_location_history?.address,
                updateDate: this.resArray[i]?.truck_location_history?.createdAt,
                location: {
                  lat: Number(
                    this.resArray[i]?.truck_location_history?.latitude
                  ),
                  lng: Number(
                    this.resArray[i]?.truck_location_history?.longitude
                  ),
                },
                geofenceRadius: this.resArray[i]?.geofenceRadius,
              });
            }
            this.refreshMaplibreMarkers();
          }
        },
        (err) => {
          this.isLoading = false;
          console.error("Failed to query vehicle track telemetry:", err);
          if (err.error?.message === "jwt expired" || err.error?.message === "jwt malformed") {
            window.localStorage.clear();
            this.router.navigateByUrl("admin/login");
          }
        }
      );

    this.subscriptions.push(subscription);
  }

  initialTruckData: any[] = [];

  addMarker(locationInfo: any) {
    const isSearchedTruck =
      locationInfo.truckNumber === this.truckNo ||
      locationInfo.driverName
        ?.toLowerCase()
        .includes(this.truckNo?.toLowerCase()) ||
      locationInfo.address?.toLowerCase().includes(this.truckNo?.toLowerCase());

    if (!this.truckNo || isSearchedTruck) {
      let truckLocDetails = this.markerPositions.find((item: any) => {
        return item.truckNumber === locationInfo.truckNumber;
      });

      if (
        !truckLocDetails ||
        (truckLocDetails.location &&
          (truckLocDetails.location.lat !== locationInfo.location.lat ||
            truckLocDetails.location.lng !== locationInfo.location.lng))
      ) {
        this.markerPositions = this.markerPositions.filter(
          (item: any) => item.truckNumber !== locationInfo.truckNumber
        );
        this.markerPositions.push(locationInfo);
      }
    }
  }

  getMarkerIcon(markerPosition: any): string {
    let iconPath = "";
    if (
      markerPosition.truckStatus === "online" ||
      markerPosition.tripdetails?.trip_status === "completed" ||
      markerPosition.tripStatus === "completed"
    ) {
      iconPath = "assets/img/truck_green.png";
    } else if (
      markerPosition.truckStatus === "online" &&
      (markerPosition.tripdetails?.trip_status === "tripstarted" ||
        markerPosition.tripdetails?.trip_status === "inprogress" ||
        markerPosition.tripStatus === "tripstarted" ||
        markerPosition.tripStatus === "inprogress")
    ) {
      iconPath = "assets/img/truck_blue.png";
    } else {
      iconPath = "assets/img/truck_gray.png";
    }
    return iconPath;
  }

  getDotClass(item: any): string {
    const truckStatus = item.driverRouteDetails?.driver_route_status || "offline";
    const tripStatus = item.tripdetails?.trip_status || item.tripStatus;

    if (
      truckStatus === "online" &&
      (tripStatus === "inprogress" || tripStatus === "tripstarted")
    ) {
      return tripStatus;
    }
    return truckStatus;
  }

  refreshMaplibreMarkers(fitBounds = true) {
    if (!this.map) return;

    const activeTruckNumbers = new Set(this.markerPositions.map((pos: any) => pos.truckNumber));

    // Remove markers that are no longer active
    const markersToRemove = this.maplibreMarkers.filter(m => {
      const tNo = (m as any).truckNumber;
      return !activeTruckNumbers.has(tNo);
    });
    markersToRemove.forEach(m => {
      if ((m as any).animationFrameId) {
        cancelAnimationFrame((m as any).animationFrameId);
      }
      m.remove();
    });
    this.maplibreMarkers = this.maplibreMarkers.filter(m => activeTruckNumbers.has((m as any).truckNumber));

    // Add or update markers
    this.markerPositions.forEach((pos: any, index: number) => {
      if (!pos.location || !pos.location.lng || !pos.location.lat) return;

      const existingMarker = this.maplibreMarkers.find(m => (m as any).truckNumber === pos.truckNumber);
      const iconUrl = this.getMarkerIcon(pos);

      if (existingMarker) {
        // Guard selected truck from standard linear LERP interpolation if route is loaded
        if (pos.truckNumber === this.isSelectedTruck && this.isRouteLoaded) {
          (existingMarker as any).markerData = pos;
          (existingMarker as any).markerIndex = index;
          const el = existingMarker.getElement();
          if (el) {
            const innerEl = el.querySelector(".marker-icon-inner") as HTMLElement;
            if (innerEl) {
              innerEl.style.backgroundImage = `url(${iconUrl})`;
            }
            el.title = `${pos.driverName || 'N/A'}\n${pos.truckNumber}`;
          }
          return;
        }

        // Update position smoothly
        const startLngLat = existingMarker.getLngLat();
        const start: [number, number] = [startLngLat.lng, startLngLat.lat];
        const end: [number, number] = [pos.location.lng, pos.location.lat];

        // Animate marker from current position to new position
        if (start[0] !== end[0] || start[1] !== end[1]) {
          const bearing = this.calculateBearing(start[1], start[0], end[1], end[0]);
          const el = existingMarker.getElement();
          const innerEl = el.querySelector(".marker-icon-inner") as HTMLElement;
          if (innerEl) {
            innerEl.style.transform = `rotate(${bearing}deg)`;
          }
          this.animateMarker(existingMarker, start, end, 2000);
        }

        // Update dynamic data bindings for the click handler and element styling
        (existingMarker as any).markerData = pos;
        (existingMarker as any).markerIndex = index;
        const el = existingMarker.getElement();
        if (el) {
          const innerEl = el.querySelector(".marker-icon-inner") as HTMLElement;
          if (innerEl) {
            innerEl.style.backgroundImage = `url(${iconUrl})`;
          }
          el.title = `${pos.driverName || 'N/A'}\n${pos.truckNumber}`;
        }
      } else {
        // Create nested marker elements (outer container 'el', inner rotated icon 'innerEl')
        const el = document.createElement("div");
        el.className = "maplibre-marker";
        el.style.width = "32px";
        el.style.height = "32px";
        el.style.cursor = "pointer";

        const innerEl = document.createElement("div");
        innerEl.className = "marker-icon-inner";
        innerEl.style.backgroundImage = `url(${iconUrl})`;
        innerEl.style.width = "100%";
        innerEl.style.height = "100%";
        innerEl.style.backgroundSize = "contain";
        innerEl.style.backgroundRepeat = "no-repeat";
        innerEl.style.backgroundPosition = "center";
        innerEl.style.transition = "transform 0.5s ease-in-out"; // smooth rotation animation

        // Initial rotation: check if it's the tracked truck and we have history, otherwise use course
        let initialBearing = 0;
        if (pos.truckNumber === this.isSelectedTruck) {
          if (this.currentRouteSegments && this.currentRouteSegments.length > 0) {
            const validSegments = this.currentRouteSegments.filter((seg: any) => seg && seg.length > 1);
            if (validSegments.length > 0) {
              const lastSeg = validSegments[validSegments.length - 1];
              const p1 = lastSeg[lastSeg.length - 2];
              const p2 = lastSeg[lastSeg.length - 1];
              initialBearing = this.calculateBearing(p1[1], p1[0], p2[1], p2[0]);
            }
          } else if (this.currentRoutePoints && this.currentRoutePoints.length >= 2) {
            const lastIdx = this.currentRoutePoints.length - 1;
            const p1 = this.currentRoutePoints[lastIdx - 1];
            const p2 = this.currentRoutePoints[lastIdx];
            initialBearing = this.calculateBearing(Number(p1.latitude), Number(p1.longitude), Number(p2.latitude), Number(p2.longitude));
          } else if (pos.course) {
            initialBearing = pos.course;
          }
        } else if (pos.course) {
          initialBearing = pos.course;
        }
        innerEl.style.transform = `rotate(${initialBearing}deg)`;

        el.appendChild(innerEl);

        const m = new maplibregl.Marker({ element: el })
          .setLngLat([pos.location.lng, pos.location.lat])
          .addTo(this.map);

        (m as any).truckNumber = pos.truckNumber;
        (m as any).markerData = pos;
        (m as any).markerIndex = index;

        el.addEventListener("click", () => {
          this.marker((m as any).markerData, (m as any).markerIndex);
        });

        // Add a native tooltip on hover
        el.title = `${pos.driverName || 'N/A'}\n${pos.truckNumber}`;

        this.maplibreMarkers.push(m);
      }
    });

    // Auto fit bounds to markers if we have any and fitBounds is true
    if (fitBounds && this.markerPositions.length > 0) {
      const bounds = new maplibregl.LngLatBounds();
      this.markerPositions.forEach((pos: any) => {
        if (pos.location && pos.location.lng && pos.location.lat) {
          bounds.extend([pos.location.lng, pos.location.lat]);
        }
      });

      if (!bounds.isEmpty()) {
        this.map.fitBounds(bounds, { padding: 50, maxZoom: 14, duration: 1000 });
      }
    }
  }

  marker(item: any, i: any) {
    this.arrayMarker = item;

    if ((!this.arrayMarker.address || String(this.arrayMarker.address).toLowerCase() === 'unknown') && this.arrayMarker.location?.lat && this.arrayMarker.location?.lng) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat: Number(this.arrayMarker.location.lat), lng: Number(this.arrayMarker.location.lng) } }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results && results.length) {
          this.arrayMarker.address = results[0].formatted_address;
        }
      });
    }

    if (
      this.arrayMarker?.truckStatus === "null" ||
      this.arrayMarker?.truckStatus === undefined ||
      this.arrayMarker?.truckStatus === ""
    ) {
      this.truckOfflineStatus = true;
      this.intransit = false;
      this.truckStatus = false;
    } else if (this.arrayMarker?.truckStatus === "offline") {
      this.intransit = false;
      this.truckStatus = true;
      this.truckOfflineStatus = false;
    } else if (this.arrayMarker?.truckStatus === "online") {
      this.intransit = false;
      this.truckStatus = true;
      this.truckOfflineStatus = false;
    }

    if (
      (this.arrayMarker.truckStatus === "online" &&
        (this.arrayMarker.tripdetails?.trip_status === "tripstarted" ||
          this.arrayMarker.tripdetails?.trip_status === "inprogress")) ||
      (this.arrayMarker.tripStatus === "tripstarted" ||
        this.arrayMarker.tripStatus === "inprogress")
    ) {
      this.truckOfflineStatus = false;
      this.truckStatus = false;
      this.intransit = true;
    }
    $("#myModal").modal("show");
  }

  closeModel() {
    $("#myModal").modal("hide");
  }

  onTruckNumberChange(eve: any) {
    this.truckNo = eve.target.value.trim();
    const inputValue = this.truckNo.toLowerCase();

    // Disable the search button if nothing is typed
    this.isSearchButtonDisabled = false;

    if (inputValue === "") {
      this.trackArray = [...this.initialTruckData];
      this.search_btn = true;
      this.clear_btn = false;
      this.distanceKM = 0;
    } else {
      this.trackArray = this.initialTruckData.filter((item: any) => {
        const truckNumber = item.truck_location_history?.vehicleNumber || item.truckNumber || "";
        return truckNumber.toLowerCase().includes(inputValue);
      });
      this.search_btn = true;
      this.clear_btn = false;
    }

    this.markerPositions = this.trackArray.map((item: any) => ({
      trip_id: item.tripdetails?.trip_id,
      tripdetails: item.tripdetails,
      truckNumber: item.truck_location_history?.vehicleNumber || item.truckNumber,
      mobile: item.driverDetails?.mobile,
      driverName: item.driverDetails?.username || item.driverName,
      truckStatus: item.driverRouteDetails?.driver_route_status,
      startdate: item.truck_location_history?.trackDateTime,
      tripStatus: item.tripdetails?.trip_status,
      address: item.truck_location_history?.address || item.address,
      updateDate: item.truck_location_history?.createdAt,
      location: {
        lat: Number(item.truck_location_history?.latitude || item.location?.lat),
        lng: Number(item.truck_location_history?.longitude || item.location?.lng),
      },
      geofenceRadius: item.geofenceRadius,
    }));

    this.isDistanceFieldDisabled = this.markerPositions.length === 0;

    this.statusText = "";
    this.isRouteLoaded = false;
    this.removeRadiusLayer();
    this.removeRouteLayers();

    if (this.map) {
      if (this.markerPositions.length > 0) {
        this.refreshMaplibreMarkers(true);
      } else {
        this.refreshMaplibreMarkers(false);
        this.map.flyTo({ center: [78.9629, 20.5937], zoom: 5.11 });
      }
    }
  }

  async searchTruckTrackInfo(eve: any, isRadius: boolean) {
    this.truckNo = "";
    this.isLoading = true;
    this.truckSearchOn = true;
    this.dummyValue = eve.trim();

    if (!this.markerPositionsTemp || this.markerPositionsTemp.length === 0) {
      this.markerPositionsTemp = [...this.trackArray];
    }

    this.markerPositions = this.trackArray.map((item: any) => ({
      truckNumber: item.truck_location_history?.vehicleNumber,
      driverName: item.driverDetails?.username,
      address: item.truck_location_history?.address,
      location: {
        lat: parseFloat(item.truck_location_history?.latitude),
        lng: parseFloat(item.truck_location_history?.longitude),
      },
      tripStatus: item.tripdetails?.trip_status,
      truckStatus: item.driverRouteDetails?.driver_route_status || "",
      trip_id: item.tripdetails?.trip_id,
      driverNumber: item.driverDetails?.mobile,
      pickUpdate: item.tripdetails?.pickup_date,
      updateTime: item.truck_location_history?.updatedAt,
    }));

    this.clearPreviousTruckLocation();
    this.isReset = true;

    if (eve && eve.trim() !== "") {
      this.truckNo = eve.trim();

      const matchedTruckMarkers = await this.searchTruckByNumber(
        this.truckNo,
        isRadius
      );

      if (matchedTruckMarkers.length > 0) {
        const truckLocation = matchedTruckMarkers[0]?.location;
        this.zoomToLocation(truckLocation, 10);
      }

      this.search_btn = false;
      this.clear_btn = true;
    } else {
      this.markerPositions = this.initialTruckData;
      this.markerPositionsTemp = this.initialTruckData;
      this.trackArray = this.initialTruckData;
      this.snackBar.open("Please provide correct data.", "Close", {
        duration: 3000,
      });
      this.clear_btn = false;
      this.search_btn = true;
      this.markerPositions = [...this.markerPositionsTemp];
      this.isDistanceFieldDisabled = false;
    }

    this.isLoading = false;
  }

  setTruckLocationAndRadius(
    location: { lat: number; lng: number },
    radiusKM: number
  ) {
    this.zoomToLocation(location, 10);
    this.setRadiusLayer(location, radiusKM);
    this.checkTrucksInRadius(location, radiusKM * 1000, true);
  }

  setRadiusLayer(center: { lat: number; lng: number }, radiusKm: number) {
    if (!this.map) return;

    this.zoomToLocation(center, 10);

    const geojsonData = this.createCirclePolygon(center, radiusKm);

    if (this.map.getSource("search-circle")) {
      (this.map.getSource("search-circle") as maplibregl.GeoJSONSource).setData(geojsonData);
    } else {
      this.map.addSource("search-circle", {
        type: "geojson",
        data: geojsonData,
      });
      this.map.addLayer({
        id: "search-circle-fill",
        type: "fill",
        source: "search-circle",
        paint: {
          "fill-color": "#FF0000",
          "fill-opacity": 0.15,
        },
      });
      this.map.addLayer({
        id: "search-circle-outline",
        type: "line",
        source: "search-circle",
        paint: {
          "line-color": "#FF0000",
          "line-width": 2,
          "line-opacity": 0.6,
        },
      });
    }
  }

  removeRadiusLayer() {
    if (!this.map) return;
    if (this.map.getLayer("search-circle-fill")) this.map.removeLayer("search-circle-fill");
    if (this.map.getLayer("search-circle-outline")) this.map.removeLayer("search-circle-outline");
    if (this.map.getSource("search-circle")) this.map.removeSource("search-circle");
  }

  createCirclePolygon(center: { lat: number; lng: number }, radiusKm: number): any {
    const points = 64;
    const coords = [];
    const distanceX = radiusKm / (111.32 * Math.cos((center.lat * Math.PI) / 180));
    const distanceY = radiusKm / 110.574;

    for (let i = 0; i < points; i++) {
      const theta = (i / points) * (2 * Math.PI);
      const x = distanceX * Math.cos(theta);
      const y = distanceY * Math.sin(theta);
      coords.push([center.lng + x, center.lat + y]);
    }
    coords.push(coords[0]); // Close path
    return {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [coords],
      },
    };
  }

  async searchTruckByNumber(truckNumberOrDriver: string, isRadius: boolean) {
    const normalizedInput = truckNumberOrDriver.trim().toLowerCase();
    let filteredTrucks: any = [];
    let specificTruck: any = null;

    if (isRadius && this.distanceKM > 0) {
      this.search_btn = false;
      this.clear_btn = true;

      const isAddressSearch = this.checkMatch(normalizedInput, normalizedInput);

      if (isAddressSearch) {
        this.getLatLngFromAddress(normalizedInput)
          .then(async (location) => {
            if (location) {
              const truckLocation = {
                lat: location.lat(),
                lng: location.lng(),
              };

              const distancePromises = this.markerPositions.map((item: any) => {
                return Promise.resolve({
                  item,
                  distance: this.getDistance(
                    truckLocation.lat, truckLocation.lng,
                    item.location.lat, item.location.lng
                  )
                });
              });

              const results = await Promise.all(distancePromises);
              filteredTrucks = results
                .filter((res: any) => res.distance <= this.distanceKM)
                .map((res: any) => res.item);

              this.trackArray = filteredTrucks;
              this.markerPositions = [...this.trackArray];
              this.refreshMaplibreMarkers();
            }
          })
          .catch(() => { });
        return [];
      } else {
        specificTruck = this.markerPositions.find(
          (item: any) => item.truckNumber?.toLowerCase() === normalizedInput
        );

        if (specificTruck) {
          filteredTrucks.push(specificTruck);
        }

        const distancePromises = this.markerPositions.map((item: any) => {
          if (!specificTruck) return Promise.resolve({ item, distance: Infinity });
          return Promise.resolve({
            item,
            distance: this.getDistance(
              specificTruck.location.lat, specificTruck.location.lng,
              item.location.lat, item.location.lng
            )
          });
        });

        const results = await Promise.all(distancePromises);
        const trucksInRadius = results
          .filter((res: any) => res.distance <= this.distanceKM)
          .map((res: any) => res.item);

        filteredTrucks = Array.from(
          new Set([...filteredTrucks, ...trucksInRadius])
        );

        this.trackArray = filteredTrucks;
        this.markerPositions = [...this.trackArray];
        this.refreshMaplibreMarkers();
        return filteredTrucks;
      }
    } else {
      filteredTrucks = this.markerPositions.filter(
        (item: any) =>
          item.truckNumber?.toLowerCase().includes(normalizedInput) ||
          item.driverName?.toLowerCase().includes(normalizedInput)
      );

      if (filteredTrucks.length === 1) {
        this.clear_btn = true;
        this.search_btn = false;
        this.markerPositions = filteredTrucks;
        this.refreshMaplibreMarkers();
        return filteredTrucks;
      }
    }

    this.refreshMaplibreMarkers();
    return filteredTrucks.length > 0 ? filteredTrucks : [];
  }

  getLatLngFromAddress(address: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          resolve(results[0].geometry.location);
        } else {
          reject(new Error("Geocode was not successful: " + status));
        }
      });
    });
  }

  checkMatch(targetString: any, userInput: any): boolean {
    if (!targetString || !userInput) return false;
    const target = targetString.toLowerCase().trim();
    let userInput1 = userInput
      .toLowerCase()
      .replace(/\bindia\b/g, "")
      .trim();
    const parts = target.split(",").map((part: any) => part.trim());

    for (let part of parts) {
      if (userInput1.includes(part)) {
        return true;
      }
    }
    return false;
  }

  zoomToLocation(location: any, targetZoom: number) {
    if (!this.map) return;
    const lng = location.lng !== undefined ? location.lng : location.longitude || location.lng;
    const lat = location.lat !== undefined ? location.lat : location.latitude || location.lat;

    this.map.flyTo({
      center: [lng, lat],
      zoom: targetZoom,
      essential: true,
      duration: 1200,
    });
  }

  async checkTrucksInRadius(
    location: any,
    radius: number,
    zoom: boolean
  ) {
    const lng = location.lng !== undefined ? location.lng : location.longitude || location.lng;
    const lat = location.lat !== undefined ? location.lat : location.latitude || location.lat;

    const distancePromises = this.markerPositions.map((marker: any) => {
      return Promise.resolve({
        marker,
        distance: this.getDistance(
          lat, lng,
          marker.location.lat, marker.location.lng
        )
      });
    });

    const results = await Promise.all(distancePromises);
    const trucksInRadius = results
      .filter((res: any) => res.distance <= radius / 1000)
      .map((res: any) => res.marker);

    if (trucksInRadius.length > 0) {
      this.trucksInRadius = trucksInRadius;
      if (zoom) {
        this.zoomToLocation(trucksInRadius[0].location, 10);
      }
    }
  }

  getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of Earth in KM
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
      Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }


  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  selectTruck(item: any, isRadius: boolean) {
    this.isLoading = true;
    this.truckNo = "";
    this.zoom = 5.11;
    this.selectedTruck = item || item.truckNumber;
    this.statusText = "";
    this.isRouteLoaded = false;

    const vNo = item.truck_location_history?.vehicleNumber || item.truckNumber;
    this.selectetheTruck(vNo);

    this.distanceKM = 0;
    this.clear_btn = true;
    this.search_btn = false;

    if (vNo) {
      this.truckNo = vNo;
      this.removeRadiusLayer();
      this.removeRouteLayers();

      if (this.isReset) {
        this.markerPositions = this.trackArray.filter(
          (marker: any) =>
            marker.truck_location_history?.vehicleNumber === this.truckNo
        );
      } else {
        this.markerPositions = this.markerPositions.filter(
          (marker: any) => marker.truckNumber === this.truckNo
        );
        this.isDistanceFieldDisabled = false;
      }

      this.searchTruckTrackInfo(this.truckNo, isRadius);
      this.stopTracking();

      // Check if truck has an active trip and fetch route history (integrated from map-tile repo)
      const tripId = item.tripdetails?.trip_id;
      console.log("Fetching route history for trip ID:", item.tripdetails?.trip_id , tripId );
      this.loadTripRouteHistory(tripId, vNo);
      this.startRoutePolling(tripId, vNo);
    } else {
      this.isLoading = false;
    }
    this.shouldGetTrack = false;
  }

  loadTripRouteHistory(tripId: string, vNo: string) {
    const finalTripId = tripId;
    const url = `${environment.base_url}${environment.base_uri}trips/admin/location-history/${finalTripId}`;
    const header = new HttpHeaders({
      Authorization: "Bearer " + this.token,
    });

    this.http.get(url, { headers: header }).subscribe(
      (response: any) => {
        const json = response;
        const rawPoints = (Array.isArray(json) ? json : (json.data || [])).filter((p: any) => p.latitude && p.longitude);

        if (rawPoints.length === 0) {
          console.warn("No route points found for trip ID:", tripId);
          return;
        }

        rawPoints.sort((a: any, b: any) => new Date(a.trackDateTime).getTime() - new Date(b.trackDateTime).getTime());

        this.currentRoutePoints = rawPoints;
        this.currentRouteSegments = json.routeSegments || [];
        this.processAndRenderRoute(vNo, true);
      },
      (error) => {
        console.error("Failed to query location history for route trace:", error);
      }
    );
  }

  startRoutePolling(tripId: string, vNo: string) {
    if (this.routeIntervalId) {
      clearInterval(this.routeIntervalId);
    }
    this.routeIntervalId = setInterval(() => {
      this.pollTripRouteHistory(tripId, vNo);
    }, 10000);
  }

  stopRoutePolling() {
    if (this.routeIntervalId) {
      clearInterval(this.routeIntervalId);
      this.routeIntervalId = null;
    }
  }

  pollTripRouteHistory(tripId: string, vNo: string) {
    const url = `${environment.base_url}${environment.base_uri}trips/admin/location-history/${tripId}`;
    const header = new HttpHeaders({
      Authorization: "Bearer " + this.token,
    });

    this.http.get(url, { headers: header }).subscribe(
      (response: any) => {
        const json = response;
        const rawPoints = (Array.isArray(json) ? json : (json.data || [])).filter((p: any) => p.latitude && p.longitude);

        if (rawPoints.length === 0) return;

        rawPoints.sort((a: any, b: any) => new Date(a.trackDateTime).getTime() - new Date(b.trackDateTime).getTime());

        const lastPointTime = this.currentRoutePoints.length > 0 
          ? new Date(this.currentRoutePoints[this.currentRoutePoints.length - 1].trackDateTime).getTime() 
          : 0;

        const brandNewPoints = rawPoints.filter((p: any) => new Date(p.trackDateTime).getTime() > lastPointTime);

        if (brandNewPoints.length > 0) {
          this.currentRoutePoints = [...this.currentRoutePoints, ...brandNewPoints];
          this.currentRouteSegments = json.routeSegments || [];
          this.processAndRenderRoute(vNo, false);
        }
      },
      (error) => {
        console.error("Failed to poll location history:", error);
      }
    );
  }

  processAndRenderRoute(vNo: string, fitBounds: boolean) {
    const rawPoints = this.currentRoutePoints;
    if (!rawPoints || rawPoints.length === 0) return;

    const startTime = new Date(rawPoints[0].trackDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const endTime = new Date(rawPoints[rawPoints.length - 1].trackDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    this.statusText = `${vNo} · ${rawPoints.length} pts · ${startTime} – ${endTime}`;
    this.isRouteLoaded = true;
    this.routeVisible = true;

    const solidFeatures: any[] = [];
    const dottedFeatures: any[] = [];

    if (this.currentRouteSegments && this.currentRouteSegments.length > 0) {
      // Use segments
      const validSegments = this.currentRouteSegments.filter((seg: any) => seg && seg.length > 1);

      for (const segCoords of validSegments) {
        solidFeatures.push({
          type: "Feature",
          geometry: { type: "LineString", coordinates: segCoords },
        });
      }
      for (let i = 0; i < validSegments.length - 1; i++) {
        const from = validSegments[i][validSegments[i].length - 1];
        const to = validSegments[i + 1][0];
        dottedFeatures.push({
          type: "Feature",
          geometry: { type: "LineString", coordinates: [from, to] },
        });
      }
    } else {
      // Fallback straight lines with time-gap detection
      const GAP_MS = 5 * 60 * 1000;
      let seg = [rawPoints[0]];
      for (let i = 1; i < rawPoints.length; i++) {
        const gap = new Date(rawPoints[i].trackDateTime).getTime() - new Date(rawPoints[i - 1].trackDateTime).getTime();
        if (gap > GAP_MS) {
          if (seg.length > 1) {
            solidFeatures.push({
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: seg.map((p) => [+p.longitude, +p.latitude]),
              },
            });
          }
          dottedFeatures.push({
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [
                [+rawPoints[i - 1].longitude, +rawPoints[i - 1].latitude],
                [+rawPoints[i].longitude, +rawPoints[i].latitude],
              ],
            },
          });
          seg = [rawPoints[i]];
        } else {
          seg.push(rawPoints[i]);
        }
      }
      if (seg.length > 1) {
        solidFeatures.push({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: seg.map((p) => [+p.longitude, +p.latitude]),
          },
        });
      }
    }

    const allCoords = rawPoints.map((p: any) => [+p.longitude, +p.latitude]);
    const pointsGeoJSON = {
      type: "FeatureCollection",
      features: rawPoints.map((p: any) => ({
        type: "Feature",
        geometry: { type: "Point", coordinates: [+p.longitude, +p.latitude] },
        properties: {
          time: new Date(p.trackDateTime).toLocaleTimeString(),
          speed: parseFloat(p.device_speed || 0).toFixed(1),
          course: p.course,
        },
      })),
    };

    const startGeoJSON = {
      type: "Feature",
      geometry: { type: "Point", coordinates: allCoords[0] },
    };
    const endGeoJSON = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: allCoords[allCoords.length - 1],
      },
    };

    if (fitBounds) {
      // 1. Initial Load: draw the complete route immediately and snap the truck to the end
      const latestPoint = rawPoints[rawPoints.length - 1];
      if (this.markerPositions.length > 0) {
        const idx = this.markerPositions.findIndex((m: any) => m.truckNumber === vNo);
        if (idx !== -1) {
          this.markerPositions[idx].location = {
            lat: Number(latestPoint.latitude),
            lng: Number(latestPoint.longitude)
          };
          this.markerPositions[idx].address = latestPoint.address || this.markerPositions[idx].address;
          this.markerPositions[idx].updateTime = latestPoint.trackDateTime;
        }
      }

      this.renderRouteLayers(solidFeatures, dottedFeatures, startGeoJSON, endGeoJSON, pointsGeoJSON, allCoords, fitBounds);
      this.refreshMaplibreMarkers(fitBounds);
    } else {
      // 2. Poll Update: Animate the truck along the new segments, drawing the trail behind it
      const marker = this.maplibreMarkers.find(m => (m as any).truckNumber === vNo);
      if (marker) {
        const allNodes = this.buildFullPathNodes();
        if (allNodes.length > 0) {
          // Find the node index closest to the truck's current map coordinates
          const currentLngLat = marker.getLngLat();
          let startIndex = 0;
          let minDistance = Infinity;
          for (let i = 0; i < allNodes.length; i++) {
            const dist = this.getDistance(currentLngLat.lat, currentLngLat.lng, allNodes[i].coord[1], allNodes[i].coord[0]);
            if (dist < minDistance) {
              minDistance = dist;
              startIndex = i;
            }
          }

          const endIndex = allNodes.length - 1;
          if (startIndex < endIndex) {
            // Cancel any active animation frame
            if ((marker as any).animationFrameId) {
              cancelAnimationFrame((marker as any).animationFrameId);
            }

            // Calculate segment distances and cumulative distances to allow constant speed animation
            const segmentDistances: number[] = [];
            const cumulativeDistances: number[] = [];
            let cumulative = 0;
            cumulativeDistances[startIndex] = 0;

            for (let i = startIndex; i < endIndex; i++) {
              const d = this.getDistance(allNodes[i].coord[1], allNodes[i].coord[0], allNodes[i + 1].coord[1], allNodes[i + 1].coord[0]);
              segmentDistances[i] = d;
              cumulative += d;
              cumulativeDistances[i + 1] = cumulative;
            }
            const totalDistance = cumulative;

            // Animate over 9000ms (to finish just before next 10s poll cycle)
            const duration = 9000;
            const startTime = performance.now();

            const animate = (time: number) => {
              const elapsed = time - startTime;
              const progress = Math.min(elapsed / duration, 1);

              let currentCoord: [number, number];
              let currentBearing = 0;
              let activeIndex = startIndex;

              if (totalDistance === 0) {
                currentCoord = allNodes[endIndex].coord;
                if (endIndex > 0) {
                  currentBearing = this.calculateBearing(
                    allNodes[endIndex - 1].coord[1], allNodes[endIndex - 1].coord[0],
                    allNodes[endIndex].coord[1], allNodes[endIndex].coord[0]
                  );
                }
              } else {
                const targetDist = progress * totalDistance;

                // Find active segment
                let k = startIndex;
                for (let i = startIndex; i < endIndex; i++) {
                  if (targetDist >= cumulativeDistances[i] && targetDist <= cumulativeDistances[i + 1]) {
                    k = i;
                    break;
                  }
                }
                activeIndex = k;

                const segStartDist = cumulativeDistances[k];
                const segLength = cumulativeDistances[k + 1] - cumulativeDistances[k];
                let segProgress = 0;
                if (segLength > 0) {
                  segProgress = (targetDist - segStartDist) / segLength;
                }

                const pStart = allNodes[k].coord;
                const pEnd = allNodes[k + 1].coord;

                currentCoord = [
                  pStart[0] + (pEnd[0] - pStart[0]) * segProgress,
                  pStart[1] + (pEnd[1] - pStart[1]) * segProgress
                ];

                currentBearing = this.calculateBearing(pStart[1], pStart[0], pEnd[1], pEnd[0]);
              }

              // Update marker position
              marker.setLngLat(currentCoord);

              // Update rotation on inner container element for smooth transitions
              const el = marker.getElement();
              const innerEl = el.querySelector(".marker-icon-inner") as HTMLElement;
              if (innerEl) {
                innerEl.style.transform = `rotate(${currentBearing}deg)`;
              }

              // Re-render the polyline trail up to the current animated position
              const { solidFeatures: traversedSolid, dottedFeatures: traversedDotted } = this.getTraversedFeatures(allNodes, activeIndex, currentCoord);
              const sourceSolid = this.map.getSource("route-solid") as maplibregl.GeoJSONSource;
              const sourceDotted = this.map.getSource("route-dotted") as maplibregl.GeoJSONSource;
              if (sourceSolid) {
                sourceSolid.setData({ type: "FeatureCollection", features: traversedSolid });
              }
              if (sourceDotted) {
                sourceDotted.setData({ type: "FeatureCollection", features: traversedDotted });
              }

              // Keep position synced in local data array
              if (this.markerPositions.length > 0) {
                const idx = this.markerPositions.findIndex((m: any) => m.truckNumber === vNo);
                if (idx !== -1) {
                  this.markerPositions[idx].location = {
                    lat: currentCoord[1],
                    lng: currentCoord[0]
                  };
                }
              }

              if (progress < 1) {
                (marker as any).animationFrameId = requestAnimationFrame(animate);
              }
            };

            (marker as any).animationFrameId = requestAnimationFrame(animate);
          }
        }
      } else {
        // Fallback if marker doesn't exist
        this.refreshMaplibreMarkers(false);
      }
    }
  }

  renderRouteLayers(
    solidFeatures: any[],
    dottedFeatures: any[],
    startGeoJSON: any,
    endGeoJSON: any,
    pointsGeoJSON: any,
    allCoords: number[][],
    fitBounds = true
  ) {
    if (!this.map) return;

    const sourceSolid = this.map.getSource("route-solid") as maplibregl.GeoJSONSource;
    const sourceDotted = this.map.getSource("route-dotted") as maplibregl.GeoJSONSource;
    const sourceStart = this.map.getSource("route-start") as maplibregl.GeoJSONSource;
    const sourceEnd = this.map.getSource("route-end") as maplibregl.GeoJSONSource;
    const sourcePoints = this.map.getSource("route-points") as maplibregl.GeoJSONSource;

    if (sourceSolid && sourceDotted && sourceStart && sourceEnd && sourcePoints) {
      // If layers and sources already exist, update the data dynamically to prevent flickering
      sourceSolid.setData({ type: "FeatureCollection", features: solidFeatures });
      sourceDotted.setData({ type: "FeatureCollection", features: dottedFeatures });
      sourceStart.setData(startGeoJSON);
      sourceEnd.setData(endGeoJSON);
      sourcePoints.setData(pointsGeoJSON);

      // Fit bounds to full route trace if fitBounds is true
      if (fitBounds) {
        const bounds = new maplibregl.LngLatBounds();
        allCoords.forEach((coord) => bounds.extend(coord as [number, number]));
        this.map.fitBounds(bounds, { padding: 60, duration: 1200 });
      }
    } else {
      // Otherwise, remove any existing partial layers and create everything fresh
      this.removeRouteLayers();

      // Add sources
      this.map.addSource("route-solid", {
        type: "geojson",
        data: { type: "FeatureCollection", features: solidFeatures },
      });
      this.map.addSource("route-dotted", {
        type: "geojson",
        data: { type: "FeatureCollection", features: dottedFeatures },
      });
      this.map.addSource("route-start", { type: "geojson", data: startGeoJSON });
      this.map.addSource("route-end", { type: "geojson", data: endGeoJSON });
      this.map.addSource("route-points", { type: "geojson", data: pointsGeoJSON });

      // Layers: line highlight shadow + colored overlay
      this.map.addLayer({
        id: "route-shadow",
        type: "line",
        source: "route-solid",
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#f97316", "line-width": 12, "line-opacity": 0.25 },
      });
      this.map.addLayer({
        id: "route-line",
        type: "line",
        source: "route-solid",
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#f97316", "line-width": 5 },
      });

      // Dotted route for gaps
      this.map.addLayer({
        id: "route-gap",
        type: "line",
        source: "route-dotted",
        layout: { "line-cap": "round", "line-join": "round" },
        paint: {
          "line-color": "#94a3b8",
          "line-width": 3,
          "line-dasharray": [2, 4],
        },
      });

      // Start circle
      this.map.addLayer({
        id: "route-start-outer",
        type: "circle",
        source: "route-start",
        paint: {
          "circle-radius": 10,
          "circle-color": "#fff",
          "circle-stroke-color": "#ef4444",
          "circle-stroke-width": 3,
        },
      });
      this.map.addLayer({
        id: "route-start-inner",
        type: "circle",
        source: "route-start",
        paint: {
          "circle-radius": 5,
          "circle-color": "#ef4444",
        },
      });

      // End circle
      this.map.addLayer({
        id: "route-end-outer",
        type: "circle",
        source: "route-end",
        paint: {
          "circle-radius": 10,
          "circle-color": "#fff",
          "circle-stroke-color": "#22c55e",
          "circle-stroke-width": 3,
        },
      });
      this.map.addLayer({
        id: "route-end-inner",
        type: "circle",
        source: "route-end",
        paint: {
          "circle-radius": 5,
          "circle-color": "#22c55e",
        },
      });

      // Fit bounds to full route trace
      if (fitBounds) {
        const bounds = new maplibregl.LngLatBounds();
        allCoords.forEach((coord) => bounds.extend(coord as [number, number]));
        this.map.fitBounds(bounds, { padding: 60, duration: 1200 });
      }

      // Setup interactive popups
      this.map.addLayer({
        id: "route-hit",
        type: "circle",
        source: "route-points",
        paint: {
          "circle-radius": 6,
          "circle-color": "transparent",
          "circle-stroke-color": "transparent",
          "circle-stroke-width": 0,
        },
      });

      const popup = new maplibregl.Popup({ closeButton: false, closeOnClick: false });

      this.map.on("click", "route-hit", (e: any) => {
        if (!e.features || e.features.length === 0) return;
        const { time, speed, course } = e.features[0].properties;
        popup
          .setLngLat(e.lngLat)
          .setHTML(`<strong>${time}</strong><br>Speed: ${speed} km/h<br>Course: ${course}°`)
          .addTo(this.map);
      });

      this.map.on("mouseenter", "route-hit", () => {
        this.map.getCanvas().style.cursor = "pointer";
      });
      this.map.on("mouseleave", "route-hit", () => {
        this.map.getCanvas().style.cursor = "";
      });
    }
  }

  removeRouteLayers() {
    if (!this.map) return;

    const layers = [
      "route-shadow",
      "route-line",
      "route-gap",
      "route-start-outer",
      "route-start-inner",
      "route-end-outer",
      "route-end-inner",
      "route-hit",
    ];
    layers.forEach((layer) => {
      if (this.map.getLayer(layer)) this.map.removeLayer(layer);
    });

    const sources = ["route-solid", "route-dotted", "route-start", "route-end", "route-points"];
    sources.forEach((source) => {
      if (this.map.getSource(source)) this.map.removeSource(source);
    });
  }

  resetTruckTrackInfo() {
    this.isLoading = true;
    this.isReset = false;
    this.statusText = "";
    this.isRouteLoaded = false;
    this.getTrack();
    this.selectetheTruck(null);
    this.zoom = 5.11;
    this.truckNo = "";
    this.distanceKM = 0;
    this.truckSearchOn = false;
    this.clear_btn = false;
    this.search_btn = true;
    this.trackArray = this.resArray;

    this.markerPositions = [...this.markerPositionsTemp];

    this.removeRadiusLayer();
    this.removeRouteLayers();
    this.stopRoutePolling();

    if (this.map) {
      this.map.setCenter([78.9629, 20.5937]);
      this.map.setZoom(this.zoom);
    }
  }

  // toggleRouteVisibility() {
  //   this.routeVisible = !this.routeVisible;
  //   const visibility = this.routeVisible ? "visible" : "none";
  //   const layers = [
  //     "route-shadow",
  //     "route-line",
  //     "route-gap",
  //     "route-start-outer",
  //     "route-start-inner",
  //     "route-end-outer",
  //     "route-end-inner",
  //     "route-hit",
  //   ];
  //   layers.forEach((id) => {
  //     if (this.map && this.map.getLayer(id)) {
  //       this.map.setLayoutProperty(id, "visibility", visibility);
  //     }
  //   });
  // }

  stopTracking() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
    this.stopRoutePolling();
  }

  clearPreviousTruckLocation() {
    const idx = this.markerPositions.findIndex((m: any) => m.isPrevious);
    if (idx !== -1) {
      this.markerPositions.splice(idx, 1);
    }
    this.removeRadiusLayer();
  }

  selectetheTruck(truck: any) {
    this.isSelectedTruck = truck;
  }

  calculateBearing(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const lat1Rad = (lat1 * Math.PI) / 180;
    const lat2Rad = (lat2 * Math.PI) / 180;

    const y = Math.sin(dLon) * Math.cos(lat2Rad);
    const x =
      Math.cos(lat1Rad) * Math.sin(lat2Rad) -
      Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLon);

    const brng = (Math.atan2(y, x) * 180) / Math.PI;
    return (brng + 360) % 360;
  }

  animateMarker(marker: maplibregl.Marker, startCoords: [number, number], endCoords: [number, number], duration = 2000) {
    const startTime = performance.now();
    const animate = (time: number) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Linear interpolation (lerp)
      const lng = startCoords[0] + (endCoords[0] - startCoords[0]) * progress;
      const lat = startCoords[1] + (endCoords[1] - startCoords[1]) * progress;

      marker.setLngLat([lng, lat]);

      if (progress < 1) {
        (marker as any).animationFrameId = requestAnimationFrame(animate);
      }
    };

    if ((marker as any).animationFrameId) {
      cancelAnimationFrame((marker as any).animationFrameId);
    }

    (marker as any).animationFrameId = requestAnimationFrame(animate);
  }

  buildFullPathNodes(): { coord: [number, number]; isDotted: boolean }[] {
    const nodes: { coord: [number, number]; isDotted: boolean }[] = [];
    const rawPoints = this.currentRoutePoints;
    if (!rawPoints || rawPoints.length === 0) return [];

    if (this.currentRouteSegments && this.currentRouteSegments.length > 0) {
      const validSegments = this.currentRouteSegments.filter((seg: any) => seg && seg.length > 1);
      for (let i = 0; i < validSegments.length; i++) {
        const segCoords = validSegments[i];
        for (let j = 0; j < segCoords.length; j++) {
          const isLastOfSegment = (j === segCoords.length - 1);
          const isLastSegment = (i === validSegments.length - 1);
          nodes.push({
            coord: [segCoords[j][0], segCoords[j][1]],
            isDotted: isLastOfSegment && !isLastSegment
          });
        }
      }
    } else {
      // Fallback straight lines with time-gap detection
      const GAP_MS = 5 * 60 * 1000;
      let currentSeg: any[] = [rawPoints[0]];
      const segments: any[][] = [];

      for (let i = 1; i < rawPoints.length; i++) {
        const gap = new Date(rawPoints[i].trackDateTime).getTime() - new Date(rawPoints[i - 1].trackDateTime).getTime();
        if (gap > GAP_MS) {
          segments.push(currentSeg);
          currentSeg = [rawPoints[i]];
        } else {
          currentSeg.push(rawPoints[i]);
        }
      }
      segments.push(currentSeg);

      for (let i = 0; i < segments.length; i++) {
        const seg = segments[i];
        for (let j = 0; j < seg.length; j++) {
          const isLastOfSegment = (j === seg.length - 1);
          const isLastSegment = (i === segments.length - 1);
          nodes.push({
            coord: [+seg[j].longitude, +seg[j].latitude],
            isDotted: isLastOfSegment && !isLastSegment
          });
        }
      }
    }
    return nodes;
  }

  getTraversedFeatures(nodes: any[], activeIndex: number, currentCoord: [number, number]) {
    const solidFeatures: any[] = [];
    const dottedFeatures: any[] = [];
    let currentSeg: [number, number][] = [];

    for (let i = 0; i <= activeIndex; i++) {
      currentSeg.push(nodes[i].coord);
      if (nodes[i].isDotted) {
        if (currentSeg.length > 1) {
          solidFeatures.push({
            type: "Feature",
            geometry: { type: "LineString", coordinates: currentSeg }
          });
        }
        const nextCoord = (i === activeIndex) ? currentCoord : nodes[i + 1].coord;
        dottedFeatures.push({
          type: "Feature",
          geometry: { type: "LineString", coordinates: [nodes[i].coord, nextCoord] }
        });
        currentSeg = [];
      }
    }

    if (currentSeg.length > 0) {
      currentSeg.push(currentCoord);
      if (currentSeg.length > 1) {
        solidFeatures.push({
          type: "Feature",
          geometry: { type: "LineString", coordinates: currentSeg }
        });
      }
    }

    return { solidFeatures, dottedFeatures };
  }

  ngOnDestroy(): void {
    this.stopTracking();
    this.stopRoutePolling();
    this.maplibreMarkers.forEach(m => {
      if ((m as any).animationFrameId) {
        cancelAnimationFrame((m as any).animationFrameId);
      }
    });
    if (this.map) {
      this.map.remove();
    }
  }
}
